import { render, staticRenderFns } from "./ChangeIp.vue?vue&type=template&id=f8f64c94&"
import script from "./ChangeIp.vue?vue&type=script&lang=js&"
export * from "./ChangeIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports